export default class SliderButtonHorizontal {
    private scene: Phaser.Scene;
    private sliderBar: Phaser.GameObjects.Sprite;
    private sliderBox: Phaser.GameObjects.Sprite;
    private maskSliderBar: Phaser.GameObjects.Graphics;
    private sliderHandle: Phaser.GameObjects.Sprite;
    private sliderBarPercentage: number;
    private leftLimitPositionX: number;
    private rightLimitPositionX: number;

    constructor(
        scene: Phaser.Scene,
        x: number,
        y: number,
        sliderBarPercentage: number,
        callback: (percentage: number) => void,
        selectorButton = 'slide_button_selector',
        scaleBar = 0.7,
        scaleHandle = 0.8
    ) {
        this.scene = scene;

        // Slider Bar Graphics
        this.sliderBarPercentage = sliderBarPercentage;
        this.sliderBox = this.scene.add.sprite(x, y, 'slide_button_horizontal_box', 0).setScale(scaleBar);
        this.sliderBar = scene.add.sprite(x, y, 'slide_button_horizontal_bar', 0).setScale(scaleBar);

        this.leftLimitPositionX = this.sliderBar.x - (this.sliderBar.displayWidth / 2);
        this.rightLimitPositionX = this.sliderBar.x + (this.sliderBar.displayWidth / 2);

        // Mask Slider Bar
        this.maskSliderBar = scene.make.graphics();
        const mask = new Phaser.Display.Masks.BitmapMask(scene, this.maskSliderBar);
        this.sliderBar.setMask(mask);

        // Slider Handle Graphics
        const initPositionX = this.leftLimitPositionX + (this.sliderBarPercentage * this.sliderBar.displayWidth);
        this.sliderHandle = scene.add.sprite(initPositionX, this.sliderBar.y, selectorButton, 0).setScale(scaleHandle);
        this.sliderHandle.setInteractive({ draggable: true });
        this.sliderHandle.on('drag', (_: any, dragX: number) => {
            dragX = Phaser.Math.Clamp(dragX, this.leftLimitPositionX, this.rightLimitPositionX);
            this.sliderHandle.x = dragX;
            this.sliderBarPercentage = Math.round(((dragX - this.leftLimitPositionX) * 100) / (this.sliderBar.displayWidth)) / 100;      
        });

        // Return bar percentage at dragend
        this.sliderHandle.on('dragend', () => {
            callback(this.sliderBarPercentage);
        });
    }

    public applyTweens(config: any): void {
        if(!config.targets) {
            config.targets = [];
        }
        config.targets.push(this.sliderBar);
        config.targets.push(this.sliderBox);
        config.targets.push(this.sliderHandle);
        this.scene.tweens.add(config);
    }

    public getBarPercentage(): number {
        return this.sliderBarPercentage;
    }

    public update(): void {
        this.maskSliderBar.clear();
        this.maskSliderBar.fillStyle(0xffffff);
        this.maskSliderBar.fillRect(this.leftLimitPositionX, this.sliderBar.y - 25, this.sliderBar.displayWidth * this.sliderBarPercentage, 56);

        if(this.sliderBarPercentage === 0 && this.sliderHandle.texture.getFrameNames().length == 2) {
            this.sliderHandle.setFrame(1);
        } else {
            this.sliderHandle.setFrame(0);
        }
    }
}